module.exports = __webpack_public_path__ + "static/benefits-img-9d5dafb57320fcbcaa5d92f9ec1c5250.jpg";